import { render } from "./PoliticaDePrivacidad.vue?vue&type=template&id=5ee7ebf6"
import script from "./PoliticaDePrivacidad.vue?vue&type=script&lang=js"
export * from "./PoliticaDePrivacidad.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__